export const listingDetail = {
  breadcrumb: {
    listings: "Anuncios",
    detailFallback: "Detalle",
  },
  hero: {
    noName: "Sin nombre",
    editNameTitle: "Editar nombre",
    channelConnected: "Conectado al canal (OTAs)",
    channelDisconnected: "Sin conectar al canal",
  },
  units: {
    unitsCount: "{count} unidades",
    roomsCount: "{count} habitación | {count} habitaciones",
    maxGuests: "Máx. {count} huésp.",
    searchPlaceholder: "Buscar unidad…",
    dragTitle: "Arrastrar para reordenar",
    headerRoomTypes: "TIPOS DE HABITACIÓN",
    headerLinkedUnits: "UNIDADES VINCULADAS",
    addBtnTitle: "Agregar unidad",
    movedBadge: "movido",
    unitFallback: "Unidad",
  },
  typeLabels: {
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    hotel: "Hotel",
    room: "Habitación",
    studio: "Estudio",
    fallback: "Alojamiento",
  },
  aiReception: {
    title: "Recepción IA",
  },
  toggles: {
    enableAgent: {
      label: "Habilitar agente IA",
      hint: "Automatiza la atención de tus huéspedes por WhatsApp.",
    },
    otaAgent: {
      label: "Agente IA para OTAs",
      hintOn: "Responde también mensajes de Booking, Airbnb y otras OTAs.",
      hintOff: "Requiere el agente IA activo.",
    },
  },
  status: {
    active: "Activo",
    inactive: "Inactivo",
  },
  emptyUnits: {
    title: "Sin unidades",
    subHotel: "Crea la primera habitación o unidad de este hotel para empezar a configurar tarifas y disponibilidad.",
    subDefault: "Añade la primera unidad a este anuncio para empezar a recibir huéspedes.",
    ctaPreparing: "Preparando…",
    ctaAddRoom: "Agregar habitación",
    ctaAddFirstUnit: "Agregar primera unidad",
  },
  sortBar: {
    add: "Agregar",
    addRoom: "Agregar habitación",
    saving: "Guardando…",
    done: "Listo",
    sort: "Ordenar",
    dragHint: "Arrastra para reordenar",
  },
  propOptions: {
    scheduled: "Mensajes programados",
    services: "Equipamiento y comodidades",
    locks: "Cerraduras",
    faq: "Preguntas y respuestas",
    arrival: "Instrucciones de llegada",
    checkout: "Mensaje de salida",
    welcome: "Mensaje de bienvenida",
    description: "Descripción",
    capacity: "Capacidad",
  },
  addZone: {
    titleRoom: "Añadir habitación",
    titleUnit: "Añadir unidad",
    roomLower: "habitación",
    unitLower: "unidad",
    createNew: "Crea una nueva {noun} dentro de",
    eachHas: "Cada {noun} tiene su propia configuración (descripción, capacidad, accesos…).",
    ctaPreparing: "Preparando…",
    ctaCreateRoom: "Crear habitación",
    ctaCreateUnit: "Crear unidad",
  },
  danger: {
    deleteListing: "Eliminar anuncio...",
    notePrefix: "Elimina el anuncio",
    noteSuffix: " y todas sus unidades de WACheckin. Esta acción no se puede deshacer.",
  },
  toast: {
    orderSaved: "Orden guardado correctamente",
  },
  errors: {
    loadListing: "Error al cargar el alojamiento.",
  },
  authorities: {
    title: "Autoridades",
    description: "Configura la conexión con las autoridades locales para el envío automático del parte de viajeros.",
  },
  cards: {
    knowledge: { title: "Base de conocimiento", status: "Información que usa el agente" },
    earlyAccess: { title: "Acceso temprano", status: "Horas de llegada y early check-in" },
    lateCheckout: { title: "Late checkout", status: "Salida tardía y precio" },
    extendStay: { title: "Alargar estancia", status: "Extender noches de la reserva" },
    invoicing: { title: "Emisión de facturas", status: "Datos fiscales · Verifactu friendly" },
    location: { title: "Ubicación", sub: "Dirección del alojamiento" },
    logo: { title: "Branding", sub: "Identidad visual" },
    welcome: { title: "Mensaje de bienvenida", sub: "Personaliza la bienvenida" },
    checkin: { title: "Check-in", sub: "Instrucciones y horario de entrada" },
    policies: { title: "Políticas del alojamiento", sub: "Reglas y condiciones" },
    authorities: { sub: "Registro en autoridades" },
    hotelRates: { title: "Tarifas del hotel", sub: "Tarifas base y derivadas" },
    roomManagement: { title: "Habitaciones", sub: "Tipos e inventario de habitaciones" },
    rates: { title: "Tarifas", sub: "Tarifas base y derivadas" },
    ota: { title: "Conectar OTA", subPaid: "Booking · Airbnb · Vrbo · Expedia", subUnpaid: "Requiere suscripción activa" },
    ical: { title: "iCal Calendar", sub: "Sincronización de calendarios" },
    ownerSettlement: { title: "Propietario y liquidación", sub: "Si lo gestionas para otro dueño: comisión y liquidación", subManaged: "Gestionado para {owner} · {pct}\u00a0%", subManagedNoOwner: "Gestionado · {pct}\u00a0% · sin propietario asignado" },
    otaCommissions: { title: "Comisiones de las OTAs", sub: "Lo que se queda cada OTA y lo que te llega", subActive: "La ficha muestra lo que te llega de cada reserva" },
    description: { title: "Descripción", sub: "Detalles de la unidad" },
    capacity: { title: "Capacidad", sub: "Huéspedes y camas" },
    services: { title: "Equipamiento y comodidades", sub: "Lo que ofrece, con sus fotos" },
    unitFaq: { title: "Preguntas y respuestas", sub: "Específicas de esta unidad para el agente" },
    rules: { title: "Horarios", sub: "Horarios de entrada y salida" },
    upselling: { title: "Experiencias y servicios", sub: "Servicios de upselling" },
    checkinStore: { title: "Tienda del check-in", sub: "Mándasela al huésped al entrar" },
    bookingConfirmation: { title: "Notificar nueva reserva", sub: "Avisamos al huésped por WhatsApp cuando su reserva queda confirmada" },
    arrivalInstructions: { title: "Instrucciones de llegada", sub: "Cómo llegar y entrar · con hora de envío" },
    checkoutMessage: { title: "Mensaje de salida", sub: "Recordatorio de checkout · plantilla" },
    scheduledMessages: { title: "Mensajes programados", sub: "Mensajes automáticos antes, durante y después de la estancia" },
    review: { title: "Solicitar reseña", sub: "Reputación del alojamiento" },
    identity: { title: "Verificación de identidad", sub: "Seguridad del huésped" },
    journeySim: { title: "Simular recorrido del huésped", sub: "Reproduce todo el proceso en un WhatsApp · envíalo a un móvil para test" },
    smartlocks: { title: "Cerraduras y acceso", sub: "Cómo entra el huésped" },
    integrations: { title: "Conexiones e integraciones", sub: "APIs y conexiones adicionales" },
    welcomeInline: { sub: "Mensaje propio de esta unidad" },
    newBookings: { title: "Nuevas reservas" },
  },
  badges: {
    ai: "IA",
    setup: "Setup",
    hotel: "Hotel",
    subscription: "Suscripción",
    comingSoon: "Próximamente",
    test: "Test",
    manager: "Gestor",
    active: "Activo",
  },
  sections: {
    essential: { title: "Configuración esencial", description: "Ajustes básicos necesarios para publicar y gestionar el alojamiento." },
    management: { title: "Gestión del alojamiento", description: "Configura tarifas, disponibilidad y canales de venta." },
    direct: { title: "Detalla esta unidad", description: "Información adicional que usamos para reservas directas y nutrir al Agente IA." },
    guest: { title: "Experiencia del huésped", description: "Configura la comunicación antes, durante y después de la estancia." },
    access: { title: "Acceso e integraciones", description: "Gestiona accesos, cerraduras y conexiones externas." },
  },
  otaModal: {
    title: "Conexión con OTAs",
    html: "Conectar Booking, Airbnb, Vrbo, Expedia (channel manager) requiere una <b>suscripción activa</b>.<br><small>Mientras tanto puedes usar el resto de funciones y sincronizar calendarios por iCal (gratis).</small>",
    confirm: "Activar suscripción",
    cancel: "Ahora no",
  },
};
